export default __webpack_public_path__ + "9bc4060dfc110a82f83b2c8de3eed839.svg";